import { render, staticRenderFns } from "./sidebar-terminplanung-card-plan-zimmerkontingente.vue?vue&type=template&id=87baf584&scoped=true"
import script from "./sidebar-terminplanung-card-plan-zimmerkontingente.vue?vue&type=script&lang=js"
export * from "./sidebar-terminplanung-card-plan-zimmerkontingente.vue?vue&type=script&lang=js"
import style0 from "./sidebar-terminplanung-card-plan-zimmerkontingente.vue?vue&type=style&index=0&id=87baf584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87baf584",
  null
  
)

export default component.exports